{
  "iconStyle": {
    "alignment": "Alignment",
    "screen": "Screen aligned",
    "north": "North aligned"
  },
  "mapObjectSelectionHelpers": {
    "layerNotVisible": {
      "message": "Selected map object is on a visually hidden layer",
      "cta": "Toggle visibility"
    },
    "objectOnDifferentLevel": {
      "message": "Selected map object is on a different level",
      "cta": "Switch level"
    },
    "layerNotVisibleAndObjectOnDifferentLevel": {
      "message": "Selected map object is on a visually hidden layer and on a different level",
      "cta": "Toggle visibility and switch level"
    }
  },
  "dates": {
    "objectDetails": {
      "noRangesAvailable": "No ranges",
      "rangeAvailable": "1 range",
      "rangesAvailable": "{{ rangesAmount }} ranges",
      "add": "Add date and time ranges",
      "noDataAvailable": "No data available"
    },
    "dateRangeAttribute": {
      "name": "Name",
      "dates": "Dates",
      "time": "Time"
    },
    "startDate": "Start date",
    "attributeName": "Date & Time Range (e.g. Shifts)",
    "attributeInfoBox": {
      "title": "Example data values",
      "infoBlurb": "Use this attribute to define the range of dates and times you want the map object to be visible. For example, ‘<strong>John’s morning shift</strong>’ will show between <strong>9:45 AM</strong> and <strong>17:45 PM</strong>. This visibility can also be determined by the selection in the map’s date and time range on the bottom right of the map.",
      "johnsMorningShift": "John’s morning shift"
    },
    "attributeSettings": "Attribute settings",
    "addRange": "Add range",
    "mapObjectDateFiltered": "Selected map object is filtered by the date selected",
    "mapObjectDateFilteredCta": "Remove the date filter",
    "tooltip": {
      "title": "Recurring date & time range",
      "blurb": "Use this feature to set repeating ranges for a specific event over regularly occurring dates. E.g. Employee shifts"
    },
    "calendarTooltip": "Date & Time Map Filter"
  },
  "ranges": "ranges",
  "digitalTwin": {
    "loading": {
      "header": "Building your Digital Twin",
      "message": "This may take a few moments"
    },
    "restarting": {
      "header": "Oops!",
      "message": "Sorry, something went wrong. We're getting you reconnected to the digital twin..."
    }
  },
  "styles": {
    "arrows": {
      "sameAsLine": "Same as line",
      "custom": "Custom"
    },
    "customImage": "Custom image",
    "customColour": "Custom colour",
    "selectImage": "Select custom image",
    "customImagePerModel": "You can only upload 1 image per model. You can replace your selection below.",
    "customImageAspectRatio": "This image is not the specified aspect ratio of {{ aspectRatio }}. It may appear stretched or squashed."
  },
  "moveLayer": {
    "front": "Bring to front",
    "back": "Send to back"
  },
  "controls": {
    "user_location": "User location"
  },
  "deleteAttributePrompt": {
    "title": "Are you sure you want to delete this attribute?",
    "message": "This will remove the attribute data from all the objects in this layer permanently. This action is not reversible."
  },
  "fileUpload": {
    "image_comment": "Upload image to comment",
    "invalid": "The file you have uploaded is invalid. Please upload a valid .png, .jpg or .jpeg file"
  },
  "comments": {
    "edit": "Edit comment",
    "delete": "Delete comment",
    "image": "Add image",
    "replaceImage": "Replace image"
  },
  "upload_asset": {
    "icon": "icon",
    "model": "3D model",
    "upload_model": "Upload a 3D model",
    "update_model": "Update 3D model",
    "upload_icon": "Upload an icon",
    "update_icon": "Edit icon",
    "name": "Name of {{ assetType }}",
    "categories": "Categories",
    "search_for_categories": "Search for categories",
    "select_asset": "Select {{ assetType }}",
    "select_file": "Select file",
    "file_end": "File must end in",
    "or": "or",
    "not_support_custom_image": "The model you've upload doesn't support custom images. To see how to enable this, view the article ",
    "select_thumbnail": "Thumbnail",
    "something_went_wrong": "Something went wrong",
    "image_size": "Image size",
    "image_style": "Image style",
    "image_file": "Image file",
    "enable_colour_customisation": "Enable colour customisation"
  },
  "permissionTooltip": "You don't have permission to ",
  "createLayerOptions": "Create layer options",
  "cancelDrawing": "Cancel drawing",
  "deleteObject": "Delete Object",
  "importNoWebSocketsToast": "Layer(s) have finished importing/copying, refresh to see the layers",
  "refresh": "Refresh"
}